<div class="container-button flex" [matMenuTriggerFor]="menu">
  <button class="menu-button">
    {{ completeUserName | uppercase | slice : 0 : 1 }}
  </button>
  <mat-icon class="arrow">keyboard_arrow_down</mat-icon>
</div>
<mat-menu class="mat-menu" #menu="matMenu">
  <button [disabled]="true" mat-menu-item class="username menu-item">{{ this.completeUserName }}</button>
  <button mat-menu-item (click)="logout()" class="menu-item">{{ 'general.exit' | translate }}</button>
</mat-menu>
